window.formStyles = window.formStyles || new Map();

window.formStyles.set("fix-close-btn-color", `
  [class*="_formCloseButton_"]:not([class*="_withBackground_"]) svg { 
    fill: #ffffff !important; 
  }
`);

window.formStyles.set("forms-bg-fix", `
  [class*="_overlayBackground_"] {
    background-color: rgba(0, 0, 0, 0.4) !important;
    opacity: 1 !important;
    visibility: visible !important;
  }

  section[data-sizing="form-wrapper"] {
    position: relative;
    justify-items: end;
    display: grid !important;
    grid-template-columns: minmax(var(--min-form-width), var(--container-max-w)) !important;
    --container-max-w: 650px !important;
    --forms-padding-top: 48px !important;
    --forms-padding-bottom: 48px !important;
    --form-container-background-size: cover;
    --container-text-alignment: left;
    [class*="_imageLoaded_"] {
      position: absolute;
      inset: 0;
      width: 100% !important;
      height: 100% !important;
      min-height: 100%;
      grid-column: 1;
      grid-row: 1;
      display: block;
      border-radius: var(--container-border-radius);
      overflow: hidden;
      z-index: 0;
      pointer-events: none;
    }
    [class*="_gridItemContent_"] {
      width: 260px;
      grid-column: 1;
      grid-row: 1;
      z-index: 1;
    }
    [class*="_formContainerCloseButtonPosition_"] { top: 30px; z-index: 2; }
    [class*="_formHeader_"] { margin: 5px auto 10px; }
    [class*="_formHeader_"] [class*="_textBody_"] strong { font-weight: 400; }
    [class*="_formDisclaimer_"] { display: none; }
    h2[class*="_textHeading_"] { font-size: 24px; }
    h2[class*="_textHeading_"]::before {
      content: "Welcome to Droneer Shop";
      display: block;
      margin-bottom: 6px;
      font-size: 12px;
      line-height: 1.2;
      font-weight: 400;
      color: currentColor;
    }
    input[class*="_formInputField_"] { border-radius: 40px !important; }
    button[class*="_formSubmitButton_"] { border-radius: 40px !important; }
    [class*="_formBannerContainer_"] {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    [class*="_formBannerHeading_"] {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      order: 1;
    }
    [class*="_formBannerHeading_"]::before {
      content: "";
      width: 32px;
      height: 32px;
      flex: 0 0 32px;
      background: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='16' cy='16' r='14.5' stroke='%2337EF80' stroke-width='2'/%3E%3Cpath d='M10 16.4L14 20.3L22 12.4' stroke='%2337EF80' stroke-width='2.3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center / contain no-repeat;
    }
    [class*="_formBannerContainer_"] > [class*="_textBody_"] {
      order: 2;
      margin-top: 10px;
      margin-bottom: 0;
      font-size: 14px;
      line-height: 1.4;
      color: rgba(255, 255, 255, 0.82);
    }
    [class*="_formBannerContainer_"] > button[class*="_copyToClipboardButton_"] {
      order: 3;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      width: fit-content;
      min-width: 214px;
      padding: 0 18px;
      margin-top: 14px;
      min-height: 38px;
      border: 1px solid rgba(255, 255, 255, 0.72);
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.02);
      color: #fff;
      overflow: hidden;
    }
    [class*="_formBannerContainer_"] > button[class*="_copyToClipboardButton_"] [class*="_textBody_"] {
      order: 1;
      padding: 0;
      font-size: 16px;
      font-weight: 700;
      color: #fff;
    }
    [class*="_formBannerContainer_"] > button[class*="_copyToClipboardButton_"]::after {
      content: "COPY";
      order: 3;
      font-size: 16px;
      line-height: 41px;
      color: #fff;
      font-family: Arial, sans-serif;
    }
    [class*="_formBannerContainer_"] > button[class*="_copyToClipboardButton_"].forms-copy-copied::after {
      content: "COPIED";
    }
    [class*="_formBannerContainer_"] > button[class*="_copyToClipboardButton_"] [class*="_copyIcon_"] {
      order: 2;
      width: 1px;
      height: 20px;
      margin-right: 0;
      margin-left: 0;
      color: rgba(255, 255, 255, 0.7);
      background: rgba(255, 255, 255, 0.7);
    }
    [class*="_formBannerContainer_"] > button[class*="_copyToClipboardButton_"] [class*="_copyIcon_"] svg {
      display: none;
    }
    [class*="_imageLoaded_"]::before,
    &::before {
      content: "";
      position: absolute;
      inset: 0;
      z-index: 0;
      pointer-events: none;
      border-radius: inherit;
      background-image: var(--form-container-background-image);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

  @media (max-width: 768px) {
    section[data-sizing="form-wrapper"] {
      width: 328px;
      height: 530px;
      justify-items: center;
      --forms-padding-bottom: 215px !important;
      --forms-padding-top: 20px !important;
      --container-text-alignment: center;
      --form-container-background-size: cover;
      [class*="_gridItemContent_"] {
        margin-top: -50px;
      }
      [class*="_formBannerHeading_"] {
        align-items: center;
        width: 100%;
      }
      [class*="_formBannerContainer_"] > button[class*="_copyToClipboardButton_"] {
        margin: 14px auto 0;
      }
      
      --form-container-background-image: url("//shop.droneer.com/cdn/shop/files/forms_background_mobile.jpg?v=1787706922&width=1600") !important;
      
    }
  }

  button[data-testid="form-teaser"] {
    border-radius: 40px !important;
  }
`);

function bindFormsCopyButtonState(root) {
  if (!root) {
    return;
  }

  root.querySelectorAll('button[class*="_copyToClipboardButton_"]').forEach((button) => {
    if (button.dataset.copyStateBound === "true") {
      return;
    }

    button.dataset.copyStateBound = "true";
    button.addEventListener("click", () => {
      button.classList.add("forms-copy-copied");

      clearTimeout(button.copyStateTimer);
      button.copyStateTimer = setTimeout(() => {
        button.classList.remove("forms-copy-copied");
      }, 3000);
    });
  });
}

const observedFormsCopyRoots = new WeakSet();

function observeFormsCopyRoot(root) {
  if (!root || observedFormsCopyRoots.has(root)) {
    return;
  }

  observedFormsCopyRoots.add(root);

  const observer = new MutationObserver(() => {
    bindFormsCopyButtonState(root);
  });

  observer.observe(root, {
    childList: true,
    subtree: true
  });
}

function bindFormsCopyButtons() {
  bindFormsCopyButtonState(document);
  observeFormsCopyRoot(document);

  document.querySelectorAll("*").forEach((element) => {
    if (element.shadowRoot) {
      bindFormsCopyButtonState(element.shadowRoot);
      observeFormsCopyRoot(element.shadowRoot);
    }
  });
}

function initFormsCustomizations() {
  bindFormsCopyButtons();

  const formsCopyButtonObserver = new MutationObserver(bindFormsCopyButtons);
  formsCopyButtonObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFormsCustomizations);
} else {
  initFormsCustomizations();
}
